module.exports = __webpack_public_path__ + "static/media/mip.efe95400.png";